module.exports = __webpack_public_path__ + "static/img/cut.png";